import { useDebounce } from 'hooks'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'

import { Text } from 'components/v2/Text'
import { Column, Row } from 'components/v2/Grid'
import { CaretDown, X } from 'phosphor-react'
import { updateFilter } from 'redux/modules/filters'

const TypeaheadSelect = ({ placeholder, emptyLabel, showMoreLabel, title, titleColor }) => {
  const dispatch = useDispatch()
  const { symptoms, filters } = useSelector(state => ({
    symptoms: state.symptoms,
    filters: state.filters
  }))

  const [search, setSearch] = useState('')
  const [showMore, setShowMore] = useState(false)
  const [openOptionsList, setOpenOptionsList] = useState(false)

  const debouncedSearch = useDebounce(search, 300)

  const filteredOptions = symptoms?.data.filter(option => {
    const value = option['title']
    return value.toLowerCase().includes(debouncedSearch.toLowerCase())
  })

  const handleSelect = option => {
    dispatch(updateFilter({ symptoms: [option?.title] }))
    setSearch('')
    setOpenOptionsList(false)
  }

  const handleShowMore = () => {
    setShowMore(true)
  }

  const handleSearch = value => {
    setSearch(value)
  }

  const handleClear = () => {
    dispatch(updateFilter({ symptoms: [] }))
    setSearch('')
  }

  const handleOpenOptionsList = () => {
    setOpenOptionsList(state => !state)
  }

  return (
    <Wrapper>
      <Row width='100%' alignItems='center' justifyContent='space-between'>
        <Column px={['16px']} py={['4px']} width='80%' onClick={handleOpenOptionsList}>
          <Text variant='tiny' textAlign='left' mb='8px' color={titleColor || '#7F8C8D'}>
            {title}
          </Text>
          <SearchInput
            placeholder={placeholder}
            value={search || filters?.symptoms[0] || ''}
            onChange={e => handleSearch(e.target.value)}
          />
        </Column>
        {filters?.symptoms?.length > 0 ? (
          <X size={20} color='#FF7708' onClick={handleClear} style={{ marginRight: '0.5rem' }} />
        ) : (
          <CaretDown
            size={20}
            color='#FF7708'
            onClick={handleOpenOptionsList}
            style={{ marginRight: '0.5rem' }}
          />
        )}
      </Row>

      {openOptionsList === true && (
        <OptionsList>
          {filteredOptions.slice(0, showMore ? filteredOptions?.length : 5).map(option => (
            <Option
              key={option.id}
              onClick={() => handleSelect(option)}
              selected={filters?.symptoms[0] === option.title}
            >
              {option.title}
            </Option>
          ))}
          {filteredOptions?.length > 5 && !showMore && (
            <ShowMoreButton onClick={handleShowMore}>{showMoreLabel}</ShowMoreButton>
          )}
        </OptionsList>
      )}
      {filteredOptions?.length === 0 && search && (
        <OptionsList>
          <Option>{emptyLabel}</Option>
        </OptionsList>
      )}
    </Wrapper>
  )
}

export default TypeaheadSelect

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;

  &:hover {
    cursor: pointer;
  }
`

const SearchInput = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  outline: none;
  &::placeholder {
    font-family: Sora, sans-serif;
    font-weight: 400;
    color: #2e3035 !important;
  }
`

const OptionsList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  z-index: 1;
  text-align: left;
  color: #ff7708;
`

const Option = styled.div`
  padding: 10px;
  cursor: pointer;
  background: ${props => (props.selected ? '#eee' : '#fff')};
`

const ShowMoreButton = styled.div`
  padding: 10px;
  cursor: pointer;
  background: #eee;
  text-align: center;
  color: #ff7708;
`
